export interface UserReview {
  rating: number;
  comment?: string;
  timestamp?: number;
  userEmail?: string;
  apmNumber?: string;
  userName?: string;
  title?: string;
  officeLocation?: string;
  teams?: string;
}

export interface ApmOption {
  ApmNumber: string;
  Name: string;
}

export interface RatingSubmitData {
  rating: number;
  comment?: string;
  apmNumber?: string;
}

export const extractNameFromEmail = (email: string): string => {
  const namePart = email.split('@')[0];
  return namePart
    .split('.')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const formatTimeAgo = (timestamp?: number): string => {
  if (!timestamp) return '';

  const now = Date.now();
  const diffMs = now - timestamp;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;

  return new Date(timestamp).toLocaleDateString();
};

export type FilterPeriod = 'all' | '3m' | '6m' | '1y';

export const filterReviewsByTime = (
  reviews: UserReview[],
  filterPeriod: FilterPeriod,
): UserReview[] => {
  if (filterPeriod === 'all') return reviews;

  const now = Date.now();
  let cutoffTime = now;

  if (filterPeriod === '3m') {
    cutoffTime = now - 90 * 24 * 60 * 60 * 1000;
  } else if (filterPeriod === '6m') {
    cutoffTime = now - 180 * 24 * 60 * 60 * 1000;
  } else if (filterPeriod === '1y') {
    cutoffTime = now - 365 * 24 * 60 * 60 * 1000;
  }

  return reviews.filter(review => {
    if (!review.timestamp) return false;
    return review.timestamp >= cutoffTime;
  });
};
